import { cva, type VariantProps } from "./style.utils";
import { myriadPro } from "./typography.utils";

// -----------------------------------------------------------------------------

export type RootVariants = VariantProps<typeof rootVariants>;

export const rootVariants = cva({
  base: [
    // properties/variables
    myriadPro.variable,
    // background
    "bg-root",
    // foreground
    "text-shade-100",
  ],
});

// -----------------------------------------------------------------------------

export type BodyVariants = VariantProps<typeof bodyVariants>;

export const bodyVariants = cva({
  base: "flex min-h-dvh flex-col",
});
